import { Box, Divider, Grid, Title } from '@mantine/core';

import ProductCard from './ProductCard';

const ContextProducts = ({ interactions, contextName, contextKey }) => {
  const ProductGrid = ({ products }) => {
    return products.map((productRow, index) => <Grid key={index}>{productRow}</Grid>);
  };
  const ContextHeader = ({ contextName }) => {
    if (!contextName) return null;
    return (
      <>
        <Title order={5}>{contextName}</Title>
        <Divider my="sm" />
      </>
    );
  };
  if (interactions.products[contextKey]) {
    const ids = Object.keys(interactions.products[contextKey]);
    const products = ids.map((id, i) => (
      <Grid.Col key={i} span={{ base: 12, md: 2 }}>
        <ProductCard product={interactions.products[contextKey][id]} />
      </Grid.Col>
    ));

    const productRows = [];
    for (let i = 0; i < products.length; i += 6) {
      productRows.push(products.slice(i, i + 6));
    }
    const contextProducts = (
      <>
        <ContextHeader contextName={contextName} />
        <ProductGrid products={productRows} />
      </>
    );
    return <>{productRows.length > 0 ? contextProducts : <Box ta="center">No data was found.</Box>}</>;
  }
};

export default ContextProducts;
